import DtoQualityIndicator from './DtoQualityIndicator'

export default class DtoQualityIndicators {
    constructor(obj) {
        this.stationType = obj.stationType
        this.indicators = obj.indicators.map(t => new DtoQualityIndicator(t))
    }
}

